import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MainComponent } from '@components/main/main.component';
import { ErrorResponse } from '@models/error.response';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { from, of } from 'rxjs';
import { LocaleSorterPipe } from "@pipes/locale-sorter.pipe";

import { TranslateService } from '@ngx-translate/core';
import { Setting, GeneralSetting } from '@models/setting';
import { SystemParameter } from "@models/system-parameter";
import swal from 'sweetalert2';
import { CommonService } from '@services/common.service';
import { mergeMap, reduce, switchMap } from 'rxjs/operators';
// import { CKEditor5 } from "@ckeditor/ckeditor5-angular";
import { UploadOutput, UploadFile } from "ngx-uploader";
import { I18nString } from '@app/models/i18n/i18n-string';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { BinaryFile } from '@app/models/binary-file';
import { ApplicationFile } from '@app/models/application-file';
import { SystemParameterService } from '@app/services/system-parameter.service';
import { ActionType } from '@app/types/action.type';
import { SystemCommonService } from '@app/services/system-common.service';
import { CouponGenerator, QRCodeGenerator } from '@app/models/system-common';
import { CommonResponse } from '@app/models/common-model';
import * as FileSaver from 'file-saver';

 

declare var toastr: any;
const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;

@Component({
    templateUrl: './generator.component.html',
    styleUrls: ['./generator.component.scss']
})
export class GeneratorComponent implements OnInit, AfterViewInit {

    isFieldError = FormValidationUtil.isFieldError;
    // @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    loading: boolean = false;
    clickedSave: boolean = false;
    action: ActionType;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;

    supportedFileType: string[] = ['image/jpeg', 'image/jpg', 'image/png'];

    tab: string = 'general';

    @ViewChild('generalSettingForm', { static: false }) generalSettingForm: NgForm;
    @ViewChild('generalSettingForm2', { static: false }) generalSettingForm2: NgForm;

    qrcodeGenerator: QRCodeGenerator;
    couponGenerator: CouponGenerator;

    constructor(
        private router: Router,
        public appConstant: AppConstant,
        public commonService: CommonService,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private systemParameterService: SystemCommonService
    ) {
    }

    ngOnInit(): void {
        
        this.qrcodeGenerator = new QRCodeGenerator();
        this.couponGenerator = new CouponGenerator();
         
    }

    ngAfterViewInit(): void {

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.SETTING_PATH]);
    }

      
    public genCoupon(): void {
        this.mainComponent.enableLoadingMask();
        this.loading = true;
        // this.clickedSave = true;

        // for (let key of Object.keys(this.generalSettingForm2.controls)) {
        //     this.generalSettingForm2.controls[key].markAsDirty();
        // }
        // for (let key of Object.keys(this.letterInfoSettingForm.controls)) {
        //     this.letterInfoSettingForm.controls[key].markAsDirty();
        // }
        
        let fileName = "couponList.xlsx"
        this.systemParameterService.generateCouponAndDownload(this.couponGenerator)
            .subscribe(blob => {
                    
            FileSaver.saveAs(blob, fileName);
                this.loading = false;
                this.mainComponent.disableLoadingMask();
            }, (error: ErrorResponse) => {
                this.loading = false;
                this.mainComponent.disableLoadingMask();
                if(error==null){
                    return;
                }
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            });

        // Check if forms valid
        if(3>2){
            return;
        }
        
        this.systemParameterService.genCoupon(this.couponGenerator)
            .subscribe((setting:any) => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                console.log('>>>>result file path:'+JSON.stringify(setting));
                this.translate.get(setting.messgae)
                    .pipe(
                       // switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;

                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.SETTING_PATH)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                });
        
    }

    private genQRCode(): void {
        this.mainComponent.enableLoadingMask();
        this.loading = true;

        // var con = this.qrcodeGenerator.argumentContent;

        // console.log('>argumentContent>>>'+con);

        let fileName = "qrcode.zip"

        this.systemParameterService.generateQRCodeAndDownload(this.qrcodeGenerator)
        .subscribe(blob => {
            FileSaver.saveAs(blob, fileName);
            this.loading = false;
            this.mainComponent.disableLoadingMask();
            // item._selected = false;
        }, (error: ErrorResponse) => {
            this.loading = false;
            this.mainComponent.disableLoadingMask();
            // item._selected = false;
            if(error==null){
                return;
            }
            from(error.errors)
                .pipe(
                    mergeMap(error => this.translate.get(error.errorCode)),
                    reduce((acc, value) => acc + value + '<br/>', '')
                )
                .subscribe(msg => {
                    this.translate.get(fileName)
                        .pipe(
                            switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                        )
                        .subscribe(title => {
                            toastr.options = {
                                "closeButton": true,
                                "positionClass": "toast-bottom-right",
                                "timeOut": "0",
                                "extendedTimeOut": "0"
                            }
                            toastr.error(msg, title);
                        });
                });
        });
 
    }
}
